import React, { useState } from 'react';
import {
  Paper,
  Typography,
  TextField,
  Button,
  Box,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
  QuestionAnswer,
  Help as HelpIcon
} from '@mui/icons-material';

interface FAQ {
  id: string;
  question: string;
  answer: string;
}

const mockFAQs: FAQ[] = [
  {
    id: '1',
    question: 'How do I create a new intervention plan?',
    answer: 'Navigate to the Cases section, click "New Intervention" and fill out the required information in the form.'
  },
  {
    id: '2',
    question: 'Where can I find attendance reports?',
    answer: 'Attendance reports are available in the Insights section under "Attendance Trends".'
  }
];

export const HelpDesk: React.FC = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleAccordionChange = (panel: string) => (_: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const filteredFAQs = mockFAQs.filter(faq =>
    faq.question.toLowerCase().includes(searchQuery.toLowerCase()) ||
    faq.answer.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <Paper sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
        <HelpIcon sx={{ mr: 1 }} />
        <Typography variant="h6">
          Help & Support
        </Typography>
      </Box>

      <TextField
        fullWidth
        variant="outlined"
        placeholder="Search FAQs..."
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        sx={{ mb: 3 }}
      />

      {filteredFAQs.map((faq) => (
        <Accordion
          key={faq.id}
          expanded={expanded === faq.id}
          onChange={handleAccordionChange(faq.id)}
          sx={{ mb: 1 }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>{faq.question}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography color="text.secondary">
              {faq.answer}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}

      <Box sx={{ mt: 4 }}>
        <Typography variant="subtitle1" gutterBottom>
          Need more help?
        </Typography>
        <Button
          variant="contained"
          startIcon={<QuestionAnswer />}
          fullWidth
        >
          Contact Support
        </Button>
      </Box>
    </Paper>
  );
};